document.body.addEventListener('click', function (event) {
  let target = event.target;
  while (target !== null && !target.classList.contains('productitem--action-atc') && !target.classList.contains('js-ajax-add-to-cart')) {
    target = target.parentElement;
  }
  if (target !== null && target.classList.contains('productitem--action-atc')) {
    // add to cart
    handleATCartBtnClick(target);
  } else if (target !== null && target.classList.contains('js-ajax-add-to-cart')) {
    handleAjaxBtnClick(target);
  }
});

document.body.addEventListener('click', function (e) {
  let target = e.target;
  while (
    target !== null &&
    !target.classList.contains('new_plus') &&
    !target.classList.contains('js-qtyplus') &&
    !target.classList.contains('new_minus') &&
    !target.classList.contains('js-qtyminus') &&
    !target.classList.contains('custom_cart_remove') &&
    !target.classList.contains('quantity_box_btn')
  ) {
    target = target.parentElement;
  }
  if (target != null && (target.classList.contains('new_plus') || target.classList.contains('js-qtyplus'))) {
    handleIncreaseBtn(target);
  } else if (target != null && (target.classList.contains('new_minus') || target.classList.contains('js-qtyminus'))) {
    handleDecreaseBtn(target);
  } else if (target != null && target.classList.contains('custom_cart_remove')) {
    handleDeleteBtn(target);
  } else if (target != null && target.classList.contains('quantity_box_btn')) {
    handlePDPCartBTN(target);
  }
});

async function handleATCartBtnClick(target) {
  const variantID = target.getAttribute('data-variant-id');
  let addToCartBtn = target.parentElement.querySelector('.new__btn_Qty');
  target.parentElement.classList.add('added_in_cart');
  addToCartBtn.setAttribute('disabled','true');
  const quantityValue = target.parentElement.querySelector('#qnty_val');
  quantityValue.value = parseInt(quantityValue.value) + 1;
  const property = target.getAttribute('data_property');
  
  const AddToCartBTNs = document.querySelectorAll('.productitem--action-atc')
  AddToCartBTNs && AddToCartBTNs.forEach((item) => {
    item.setAttribute('disabled', true)
  })
  
  await handleAddToCart(variantID, 1, property);
}

async function handleAjaxBtnClick(target) {
  // add to cart for product page
  const variantID = target.getAttribute('data-variant-id');
  const quantityValue = target.closest('.product-form--atc').querySelector('.form-field--qty-input input').value;
  quantityValue.value = parseInt(quantityValue.value) + 1;
  const property = target.getAttribute('data_property') || '';

  const ajaxATCBtn = document.querySelectorAll('.js-ajax-add-to-cart')
  ajaxATCBtn && ajaxATCBtn.forEach((item) => {
    item.setAttribute('disabled', true)
  });
  
  await handleAddToCart(variantID, quantityValue, property);
}

async function handleAddToCart(id, quantity, property) {
  const checkoutButton = document.querySelector('.button.custom_ceckout_');
  checkoutButton?.classList.add('disabled');
  showOverlay();
  // add to cart function
  const formdata = {
    items: [
      {
        id: id,
        quantity: quantity,
        properties: {
          _data_prop: property
        }
      },
    ],
    sections: ['cart-drawer'],
  };
  const options = {
    method: 'POST',
    body: JSON.stringify(formdata),
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetch('/cart/add.js', options);
    const responseJSON = await response.json();
    console.log('update.js', responseJSON);

    const AddToCartBTNs = document.querySelectorAll('.productitem--action-atc');
    AddToCartBTNs && AddToCartBTNs.forEach((item) => {
      item.removeAttribute('disabled');
    });
    const ajaxATCBtn = document.querySelectorAll('.js-ajax-add-to-cart');
    ajaxATCBtn && ajaxATCBtn.forEach((item) => {
      item.removeAttribute('disabled');
    });

    
    await handleFreeGift();
    await cartDrawerUpdate();
  } catch (err) {
    console.log('err..', err);
  } finally {
    checkoutButton?.classList.remove('disabled');
    hideOverlay();
  }
}
async function handleIncreaseBtn(target) {
  let allQuantitySelectors = Array.from(document.querySelectorAll('.quantity_btn'));
  if(target.classList.contains('ajax-change-quantity'));
  let selectedVariant = target.dataset.variantid;
  let selectedBtn = target.dataset.btntype;
  allQuantitySelectors.map((item)=>{
    if (item.dataset.variantId == selectedVariant && item.classList.contains(`${selectedBtn}`)){
      target = item;
    }
  })
  const checkoutButton = document.querySelector('.button.custom_ceckout_');
  const PlusQuantity = target.closest('.new_plus');
  const drawerPlusQuantity = target.closest('.js-qtyplus');
  const plus = target.previousElementSibling;
  const stockAvailable = plus.dataset.stock;
  const initInputValue = plus.value;
  if (initInputValue >= 0 && initInputValue < 5 && Number(initInputValue) < Number(stockAvailable)) {
    // disable quantity input in product card and cart drawer along with checkout button.
    checkoutButton?.classList.add('disabled');
    showOverlay();
    drawerPlusQuantity && drawerPlusQuantity.setAttribute('disabled', true) && drawerPlusQuantity.classList.add('disabled');
    PlusQuantity && PlusQuantity.setAttribute('disabled', true) && PlusQuantity.classList.add('disabled');
    
    const variantID = target.getAttribute('data-variant-id') || target.getAttribute('variantid');
    const dataLine = document.querySelector(`.custom_product_details[variant-id="${variantID}"]`)?.closest('.custom_cart_produts').getAttribute('data-line');
    let dataQuantity = document.querySelector(`.custom_product_details[variant-id="${variantID}"]`)?.getAttribute('quantty');
    dataQuantity = parseInt(dataQuantity);
    let addToCartBtn = document.querySelector('.new__btn_Qty');
    if(addToCartBtn) {
    addToCartBtn.setAttribute('disabled','true');
    }
    let line = dataLine
    if (target.closest('.custom_cart_produts')) {
      line = target.closest('.custom_cart_produts').getAttribute('data-line');
    }
    const id = line;
    const qty = parseInt(initInputValue) + 1;
    plus.value = qty;
 
    await updateCart(id, dataQuantity+1);
    
    checkoutButton?.classList.remove('disabled');
    hideOverlay();
    drawerPlusQuantity && drawerPlusQuantity.setAttribute('disabled', false) && drawerPlusQuantity.classList.remove('disabled');
    PlusQuantity && PlusQuantity.setAttribute('disabled', false) && PlusQuantity.classList.remove('disabled');
    return;
  } else if (initInputValue == 4) {
    drawerPlusQuantity && drawerPlusQuantity.setAttribute('disabled', true) && drawerPlusQuantity.classList.add('disabled');
    PlusQuantity && PlusQuantity.setAttribute('disabled', true) && PlusQuantity.classList.add('disabled');
    return;
  }
}

async function handleDecreaseBtn(target) {
  let allQuantitySelectors = Array.from(document.querySelectorAll('.quantity_btn'));
  if(target.classList.contains('ajax-change-quantity'));
  let selectedVariant = target.dataset.variantid;
  let selectedBtn = target.dataset.btntype;
  allQuantitySelectors.map((item)=>{
    if (item.dataset.variantId == selectedVariant && item.classList.contains(`${selectedBtn}`)){
      target = item;
    }
  })
  const checkoutButton = document.querySelector('.button.custom_ceckout_');
  checkoutButton?.classList.add('disabled');
  showOverlay();
  const drawerMinusQuantity = target.closest('.js-qtyminus');
  drawerMinusQuantity && drawerMinusQuantity?.setAttribute('disabled', true);
  const minusQuantity = target.closest('.new_minus');
  minusQuantity && drawerMinusQuantity?.setAttribute('disabled', true);
  
  const variantID = target.getAttribute('data-variant-id') || target.getAttribute('variantid');
  const dataLine = document.querySelector(`.custom_product_details[variant-id="${variantID}"]`)?.closest('.custom_cart_produts').getAttribute('data-line');
  let dataQty = document.querySelector(`.custom_product_details[variant-id="${variantID}"]`)?.getAttribute('quantty');
  dataQty = parseInt(dataQty);
  let addToCartBtn = document.querySelector('.new__btn_Qty');
  if(addToCartBtn) {
  addToCartBtn.setAttribute('disabled','true');
  }
  let line = dataLine;
  if (target.closest('.custom_cart_produts')) {
    line = target.closest('.custom_cart_produts').getAttribute('data-line');
  }
  const id = line;
  const minus = target.nextElementSibling;
  const qty = parseInt(minus.value) - 1;
  minus.value = qty;
  
  await updateCart(id, dataQty-1);
  if (qty < 1) {
    if (target.closest('.cstm__qty_atc')) {
      target.closest('.cstm__qty_atc').classList.remove('added_in_cart');
    }
    const quantityUpdate = document.querySelectorAll(`.quantity--${variantID}`);
    quantityUpdate && quantityUpdate.forEach((element) => {
      element.value = 0; element.closest('.cstm__qty_atc').classList.remove('added_in_cart')
    });
  }
  checkoutButton?.classList.remove('disabled');
  hideOverlay();
}

async function handleDeleteBtn(target) {
  const checkoutButton = document.querySelector('.button.custom_ceckout_');
  checkoutButton?.classList.add('disabled');
  showOverlay();
  const variantID = target.getAttribute('variant-id');
  const line = target.closest('.custom_cart_produts').getAttribute('data-line');
  await updateCart(line, 0);
  const quantityUpdate = document.querySelectorAll(`.quantity--${variantID}`);
  let cart = await cartData();
  quantityUpdate && quantityUpdate.forEach((element) => {
    const itemInCart = cart.items.some(item => item.id === Number(element.dataset.variantid));
    if(!itemInCart){
    element.value = 0; element.closest('.cstm__qty_atc').classList.remove('added_in_cart');
    }
  });
  checkoutButton?.classList.remove('disabled');
  hideOverlay();
}

async function handlePDPCartBTN(target) {
  const plusBtn = target.parentElement.querySelector('.plus');
  const input = plusBtn.previousElementSibling;
  if (input.value >= 5) {
    plusBtn.classList.add('disabled');
  } else {
    plusBtn.classList.remove('disabled');
  }
}


async function updateCart(id, quantity) {
  // update cart function
  let formdata;
  if (id.length == 1) {
    const line = id;
    formdata = {
      line,
      quantity,
      sections: ['cart-drawer'],
    };
  } else {
    formdata = {
      id,
      quantity,
      sections: ['cart-drawer'],
    };
  }
  const options = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formdata),
  };

  let currentVariantId;

  try {
   
    const response = await fetch('/cart/change.js', options);
    const responseJSON = await response.json();
    console.log('change.js', responseJSON);
    responseJSON.items.map((item) => {
      const quantityVarId = document.querySelectorAll(`.quantity--${item.variant_id}`);
      const sameProduct = responseJSON.items.filter((line) => item.variant_id == line.variant_id)
      currentVariantId = sameProduct[0].id;
      let quantity = 0;
      sameProduct.length > 0 && sameProduct.forEach((element) => quantity = quantity + element?.quantity);
      
      if (item.line_price > 0 && quantityVarId.length > 0) {
        quantityVarId.forEach((element) => {
          element.value = quantity;
          if (quantity > 0) {
            element.closest('.cstm__qty_atc')?.classList.add('added_in_cart')
          } else {
            element.closest('.cstm__qty_atc')?.classList.remove('added_in_cart')
          }
          if(Number(element.dataset.stock) >= quantity) {
            element.nextElementSibling.classList.add('plus-disabled');
          }
        });
      }
    });
    
    const newPlus = document.querySelectorAll('.new_plus');
    newPlus && newPlus.forEach((item) => {
      item.removeAttribute('disabled');
        if(item.classList.contains('plus-disabled')){
          item.classList.remove('plus-disabled');
        }
        if(Number(item.dataset.stock) <= quantity && Number(item.dataset.variantId == currentVariantId)) {
          item.classList.add('plus-disabled');
        }
    });
    const newMinus = document.querySelectorAll('.new_minus');
    newMinus && newMinus.forEach((item) => {
      item.removeAttribute('disabled');
    });

    const cart = await cartData();
    console.log(cart);
    cart.items.forEach((item)=>
    {
      if(item.quantity == 5 ){
        const element = document.querySelectorAll(`.new_plus[data-variant-id="${item.variant_id}"]`);
        if (element) {
          element.forEach((ele)=>
          {
            ele.classList.add('plus-disabled');
          })
        }
      }
    })
    
    await handleFreeGift();
  } catch (err) {
    console.log('err..', err);
  }
}

async function updateQuantityButtons() {
  const cart = await cartData();
  cart.items.forEach((item) => {
    if (item.quantity == 5) {
      const element = document.querySelectorAll(`.new_plus[data-variant-id="${item.variant_id}"]`);
      if (element) {
        element.forEach((ele)=>
        {
          ele.classList.add('plus-disabled');
        })
      }
    }
  });
  cart.items.forEach((item) => {
    const element = document.querySelectorAll(`.new_plus[data-variant-id="${item.variant_id}"]`);
      element.forEach((ele)=> {
        if (Number(element[0].dataset.stock) <= item.quantity) {
        ele.classList.add('plus-disabled');
      }
    })
  });
}

document.addEventListener('DOMContentLoaded', updateQuantityButtons );


async function cartDrawerUpdate() {
  const res = await fetch('/?sections=cart-drawer,bubble-cart-count');
  const sections = await res.json();
  let cartDrawer = await sections['cart-drawer'];
  cartDrawer = new DOMParser().parseFromString(cartDrawer, 'text/html');
  cartDrawer = cartDrawer.querySelector('#custom_cart_drawer').innerHTML;
  document.querySelector('#custom_cart_drawer').innerHTML = cartDrawer;
  let bubbleCartCount = await sections['bubble-cart-count'];
  bubbleCartCount = new DOMParser().parseFromString(bubbleCartCount, 'text/html');
  bubbleCartCount = bubbleCartCount.querySelector('#shopify-section-bubble-cart-count .top-cart-s').innerHTML;
  document.querySelector('.site-header-button .top-cart-s').innerHTML = bubbleCartCount;
  updateQuantityButtons()
  cartDrawerOpen();
}

async function cartDrawerOpen() {
  const drawer = document.querySelector('.custom_cart_drawer');
  let addToCartBtn = document.querySelectorAll('.new__btn_Qty');
  if (!drawer.classList.contains('open_cart')) {
    drawer.classList.add('open_cart');
    document.body.classList.add('cart-drawer-overlay');
    if(addToCartBtn) {
      addToCartBtn.forEach((btn)=> {
        btn.removeAttribute('disabled');
      })
    }
  } else {
    if(addToCartBtn) {
      addToCartBtn.forEach((btn)=> {
        btn.removeAttribute('disabled');
      })
    }
  }
}

function cartDrawerClose() {
  const drawer = document.querySelector('.custom_cart_drawer');
  if (drawer.classList.contains('open_cart')) {
    drawer.classList.remove('open_cart');
    document.body.classList.remove('cart-drawer-overlay');
  }
}

async function cartData() {
  const res = await fetch('/cart.js');
  const response = await res.json();
  return response;
}
// handleFreeGift
async function handleFreeGift() {
  if (!window.free_gift.enabled) {
    cartDrawerUpdate();
    console.log('freebie is disabled');
    return
  };
  const cart = await cartData();
  if (cart.cart_level_discount_applications.length > 0) {
    const variants = {
      '45629057433763': 0,
      '45629045407907': 0,
      '45629076308131': 0,
    }
    updateCartItems(variants);
    return;
  }

  let variants;
  const cartPrice = parseInt(cart.total_price / 100);
  let cartCount = 0;
  cart.items.forEach((item=>{
    if(item.price > 0) {
      cartCount = cartCount + item.quantity;
    }
  }));
  console.log(cartCount);
  // Determine the variants to add based on cart total price
  if (cartCount > 0 && cartCount <= 1 ) {
    variants = {
      '45629045407907': 1, // RFW Mini
      '45629076308131': 0, // Cleansing Pads
      '44613763203235': 0, // White Pouch
    };
  } else if (cartCount > 1) {
    variants = {
      '45629045407907': 1,
      '45629076308131': 1,
      '44613763203235': 1,
    };
  } else {
    variants = {
      '45629045407907': 0,
      '45629076308131': 0,
      '44613763203235': 0,
    };
  }

  await updateCartItems(variants);
}

async function updateCartItems(variants) {
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: {
      updates: variants
    },
    dataType: 'json',
    async: false,
    success: function (data) {
      // Add success part code here
    },
    error: function (err) {
      console.log('Error updating cart:', err);
    }
  });
  await cartDrawerUpdate();
}

document.body.addEventListener('click', async function (e) {
  const target = e.target;
  if (target.closest('.js-ajax-cart-drawer-trigger')) {
    await handleFreeGift();
    cartDrawerOpen();
  } else if (target.closest('.custom_cart_close') || !target.closest('.custom_cart_drawer')) cartDrawerClose();
});

async function fetchAndUpdateCart() {
  try {
    let cart = await cartData();
    const quantityInputs = document.querySelectorAll('.qnty_npt');
    quantityInputs.forEach((input) => {
      const variantId = input.getAttribute('data-variantid'); // Get the variant ID from the input element
      const cartItems = cart.items.filter(item => item.variant_id === Number(variantId));
      const totalQuantity = cartItems.reduce((sum, item) => sum + item.quantity, 0);
      input.value = totalQuantity;
    });
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
}

window.addEventListener('load', fetchAndUpdateCart);

function showOverlay() {
  document.getElementById("fetch-loading-overlay").style.display = "block";
}

function hideOverlay() {
  document.getElementById("fetch-loading-overlay").style.display = "none";
}
